ctrls = require.context('.', true);
ctrls.keys().forEach(ctrls);
